import { render, staticRenderFns } from "./OdemConf.vue?vue&type=template&id=19f63ef3"
import script from "./OdemConf.vue?vue&type=script&lang=js"
export * from "./OdemConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports